import {
  VIDEO_PROVIDER_BYTEPLUS_SD25,
  VIDEO_PROVIDER_VOLCENGINE_SD25,
  VIDEO_PROVIDER_BYTEPLUS_LAS_SD25,
  getSeedance25Capabilities,
  normalizeSeedance25Provider,
  normalizeSeedance25SubmissionProvider,
  normalizeSeedance25Resolution,
} from './seedance25Capabilities.js';
import { VIDEO_PROVIDER_VOLCENGINE_SEEDANCE, DOMESTIC_SEEDANCE_MODELS, isDomesticOfficialSeedance, validateDomesticSeedanceRequest } from './domesticSeedanceCapabilities.js';
const DOMESTIC_OFFICIAL_CASES = new Map(DOMESTIC_SEEDANCE_MODELS.flatMap((model, index) => ['text', 'ref'].map(mode => [`video_volcengine_seedance_${['20', 'fast', 'mini'][index]}_${mode}`, model.id])));

const MODELARK_VIDEO_CASES = new Map([
  ['video_byteplus_text', VIDEO_PROVIDER_BYTEPLUS_SD25],
  ['video_byteplus_ref', VIDEO_PROVIDER_BYTEPLUS_SD25],
  ['video_volcengine_text', VIDEO_PROVIDER_VOLCENGINE_SD25],
  ['video_volcengine_ref', VIDEO_PROVIDER_VOLCENGINE_SD25],
]);
const text = (value) => String(value ?? '').trim();

export const getProbeFixedVideoProvider = (caseId) => (
  DOMESTIC_OFFICIAL_CASES.has(caseId) ? VIDEO_PROVIDER_VOLCENGINE_SEEDANCE : MODELARK_VIDEO_CASES.get(caseId) || ''
);

export const normalizeProbeVideoParams = (caseId, params) => {
  const provider = getProbeFixedVideoProvider(caseId);
  if (!provider) return params;
  if (isDomesticOfficialSeedance(provider)) {
    const model = DOMESTIC_OFFICIAL_CASES.get(caseId);
    if (!params || typeof params !== 'object' || Array.isArray(params)) throw new Error('测试参数必须为 JSON 对象');
    if ((text(params.videoProvider) && !isDomesticOfficialSeedance(params.videoProvider)) || (text(params.provider) && !isDomesticOfficialSeedance(params.provider)) || (text(params.model) && params.model !== model)) throw new Error('此测试固定为国内官方 Seedance 对应版本，请重置厂商/模型参数');
    return validateDomesticSeedanceRequest({ ...params, videoProvider: provider, ...(params.provider ? { provider } : {}), model });
  }
  const capabilities = getSeedance25Capabilities(provider);
  if (!params || typeof params !== 'object' || Array.isArray(params)) {
    throw new Error(`${capabilities.label} 测试参数必须是 JSON 对象`);
  }
  if ((text(params.videoProvider) && normalizeSeedance25SubmissionProvider(params.videoProvider) !== provider)
    || (text(params.provider) && normalizeSeedance25SubmissionProvider(params.provider) !== provider)
    || (text(params.model) && text(params.model) !== capabilities.model)) {
    throw new Error(`此测试项固定使用 ${capabilities.label} 及其官方模型，请重置厂商/模型参数`);
  }
  return {
    ...params,
    ...(text(params.provider) ? { provider } : {}),
    videoProvider: provider,
    model: capabilities.model,
    resolution: normalizeSeedance25Resolution(provider, params.resolution),
  };
};

// Query the submitted task's identity, never the currently selected dropdown or JSON draft.
export const resolveProbeVideoTask = (run) => {
  if (run?.status === 'failed') return null;
  const caseProvider = getProbeFixedVideoProvider(run?.caseId || run?.request?.caseId);
  const result = run?.result;
  const taskId = text(result?.providerTaskId || result?.taskId || result?.task_id);
  if (!caseProvider || !taskId) return null;
  const returnedProvider = text(result?.provider || result?.videoProvider);
  const submittedProvider = text(run?.request?.params?.videoProvider || run?.request?.provider);
  if (isDomesticOfficialSeedance(caseProvider)) {
    if ((returnedProvider && !isDomesticOfficialSeedance(returnedProvider)) || (submittedProvider && !isDomesticOfficialSeedance(submittedProvider))) return null;
    return { provider: caseProvider, taskId, extra: { projectId: run?.request?.projectId, episodeId: run?.request?.episodeId, model: DOMESTIC_OFFICIAL_CASES.get(run?.caseId || run?.request?.caseId) } };
  }
  // The old case IDs were ModelArk before LAS. No identity upgrade is allowed
  // for status requests, including old runs without an explicit provider.
  const expectedProvider = normalizeSeedance25Provider(returnedProvider || submittedProvider)
    || (!returnedProvider && !submittedProvider ? caseProvider : '');
  if (expectedProvider === VIDEO_PROVIDER_BYTEPLUS_LAS_SD25) return null;
  if (expectedProvider !== caseProvider
    || (returnedProvider && normalizeSeedance25Provider(returnedProvider) !== expectedProvider)
    || (submittedProvider && normalizeSeedance25Provider(submittedProvider) !== expectedProvider)) return null;
  return {
    provider: expectedProvider,
    taskId,
    extra: {
      projectId: run?.request?.projectId,
      episodeId: run?.request?.episodeId,
      model: getSeedance25Capabilities(expectedProvider).model,
    },
  };
};
